export default __webpack_public_path__ + "static/media/Bureau_Veritas_1828_logo.d871179e.png";